/** UTC calendar arithmetic shared by reporting periods and schedule windows. */
const DAY_MS = 86_400_000;
const WEEK_MS = 7 * DAY_MS;
/** UTC midnight without Date.UTC's implicit 1900 offset for years 0–99. */
function utcDateMs(year, month, day) {
    const date = new Date(0);
    date.setUTCFullYear(year, month, day);
    return date.getTime();
}
/** UTC midnight of the Monday opening an ISO week (week-year, not calendar year). */
export function isoWeekMonday(isoYear, week) {
    // 4 January is always inside week 1.
    const jan4 = utcDateMs(isoYear, 0, 4);
    const jan4Weekday = (new Date(jan4).getUTCDay() + 6) % 7;
    return jan4 - jan4Weekday * DAY_MS + (week - 1) * WEEK_MS;
}
/** The ISO week-year and week number holding a UTC instant in milliseconds. */
export function isoWeekOf(ms) {
    const weekday = (new Date(ms).getUTCDay() + 6) % 7;
    const thursday = ms + (3 - weekday) * DAY_MS;
    const isoYear = new Date(thursday).getUTCFullYear();
    const dayOfYear = Math.floor((thursday - utcDateMs(isoYear, 0, 1)) / DAY_MS) + 1;
    return { isoYear, week: Math.ceil(dayOfYear / 7) };
}
/** UTC midnight on the containing week's Monday; does not mutate the input. */
export function isoWeekStart(date) {
    const day = date.getUTCDay();
    const backToMonday = day === 0 ? 6 : day - 1;
    return new Date(utcDateMs(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() - backToMonday));
}
/** 52 or 53; 28 December always falls in the ISO year's last week. */
export function weeksInYear(isoYear) {
    return isoWeekOf(utcDateMs(isoYear, 11, 28)).week;
}
/** Format YYYY-Www; throws RangeError for unsupported years or invalid weeks. */
export function formatIsoWeekKey(isoYear, week) {
    if (!Number.isInteger(isoYear) || isoYear < 0 || isoYear > 9999) {
        throw new RangeError("ISO week-key year must be an integer from 0 to 9999");
    }
    if (!Number.isInteger(week) || week < 1 || week > weeksInYear(isoYear)) {
        throw new RangeError("Week must exist in the specified ISO year");
    }
    return `${String(isoYear).padStart(4, "0")}-W${String(week).padStart(2, "0")}`;
}
/** Null for malformed keys or a week outside that ISO year's 52/53 weeks. */
export function parseIsoWeekKey(key) {
    const match = /^(\d{4})-W(\d{2})$/.exec(key);
    if (!match)
        return null;
    const isoYear = Number(match[1]);
    const week = Number(match[2]);
    return week >= 1 && week <= weeksInYear(isoYear) ? { isoYear, week } : null;
}
//# sourceMappingURL=calendar-period.js.map